export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14509.cde4762f.jpg";